import React, { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const RTLContext = createContext();

export const useRTL = () => {
  const context = useContext(RTLContext);
  if (!context) {
    throw new Error('useRTL must be used within RTLProvider');
  }
  return context;
};

export const RTLProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [isRTL, setIsRTL] = useState(false);
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    const updateDirection = () => {
      const currentLang = i18n.language;
      const rtl = currentLang === 'he';
      const dir = rtl ? 'rtl' : 'ltr';

      setIsRTL(rtl);
      setDirection(dir);

      // Update document attributes
      document.documentElement.dir = dir;
      document.documentElement.lang = currentLang;

      // Add/remove RTL class for additional styling hooks
      if (rtl) {
        document.body.classList.add('rtl');
      } else {
        document.body.classList.remove('rtl');
      }
    };

    // Initial setup
    updateDirection();

    // Listen for language changes
    i18n.on('languageChanged', updateDirection);

    return () => {
      i18n.off('languageChanged', updateDirection);
    };
  }, [i18n]);

  const value = {
    isRTL,
    direction,
    // Helper functions for conditional classes
    rtlClass: (ltrClass, rtlClass) => isRTL ? rtlClass : ltrClass,
    dirClass: (className) => isRTL ? `rtl:${className}` : className,
  };

  return <RTLContext.Provider value={value}>{children}</RTLContext.Provider>;
};